import axiosInstance from './AxiosInstance';
import qs from 'qs';

class ApplicationsService {

  constructor() {
    this.endpoint = "/api/applications"
  }

  async getAll(params) {
    if (`${params?.delimitationID}`.trim()?.length === 0) {
      delete params.delimitationID;
      delete params.delimitationLevelID;
    }

    try {
      const response = await axiosInstance.get(this.endpoint, {
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getByID(id) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
  async getSearchApplication(params, searchValue, searchType) {
    if (`${params?.delimitationID}`.trim()?.length === 0) {
      delete params.delimitationID;
      delete params.delimitationLevelID;
    }
    try {
      const response = await axiosInstance.get(`${this.endpoint}/search/${searchValue}/${searchType}`, {
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getByReferenceNumber(referenceNumber) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/referencenumber/${referenceNumber}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }


  async withdraw(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/withdraw`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
  async recommend(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/objections/recommend`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async accept(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/accept`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async reject(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/reject`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  
  async CreateObjection(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/objections`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
  async verify(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/verify`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async getRulesByID(id) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/${id}/rules`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getNotificationsByID(id) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/${id}/notifications`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBinaryDataByID(id) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/${id}/binarydata`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getRemovalBinaryDataByID(id) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/removals/${id}/binarydata`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getStats(params) {
    try {
      const response = await axiosInstance
        .get(`${this.endpoint}/stats`, {
          params
        });
      return response.data;
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  }
  async refer(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/refer`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async getAllCorrections(){
   try {
            const response = await axiosInstance.get(`${this.endpoint}/corrections`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

     async getCorrectionAttributes(){
      try {
                const response = await axiosInstance.get(`${this.endpoint}/correction/attributes`);
                return response.data;
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
    }

  async createCorrection(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/correction`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
}

const applicationsService = new ApplicationsService();

export { applicationsService };